import React from "react";
import { Link, useLocation } from "react-router-dom";
import {
  FiGrid,
  FiBookOpen,
  FiCreditCard,
  FiLayers,
  FiKey,
} from "react-icons/fi";
import { isToolAvailable, resolveToolsBase } from "./toolsConfig";

const ToolsHeader = ({
  title = "Business Tools",
  subtitle = "Manage your books, projects, and leases in one place.",
  actions,
  basePath = "/partner/tools",
}) => {
  const location = useLocation();
  const currentPath = location.pathname;

  const resolvedBase = resolveToolsBase(currentPath, basePath);

  const navItems = [
    {
      to: resolvedBase,
      label: "Overview",
      icon: FiGrid,
      exact: true,
    },
    {
      to: `${resolvedBase}/khatabook`,
      label: "Khatabook",
      icon: FiBookOpen,
      toolId: "khatabook",
    },
    {
      to: `${resolvedBase}/cashbook`,
      label: "Cashbook",
      icon: FiCreditCard,
      toolId: "cashbook",
    },
    {
      to: `${resolvedBase}/projects`,
      label: "Project Ledger",
      icon: FiLayers,
      toolId: "projects",
    },
    {
      to: `${resolvedBase}/leases`,
      label: "Lease Management",
      icon: FiKey,
      toolId: "leases",
    },
  ].filter((item) => !item.toolId || isToolAvailable(resolvedBase, item.toolId));

  const isTabActive = (item) => {
    if (item.exact) {
      return currentPath === item.to || currentPath === `${item.to}/`;
    }
    return currentPath === item.to || currentPath.startsWith(`${item.to}/`);
  };

  return (
    <div className="tools-header">
      <div className="tools-header__top">
        <div className="tools-header__title-group">
          <h2>{title}</h2>
          {subtitle && <p>{subtitle}</p>}
        </div>
        {actions && <div className="tools-header__actions">{actions}</div>}
      </div>

      <nav className="tools-nav-tabs" aria-label="Tools Navigation">
        {navItems.map((item) => {
          const Icon = item.icon;
          const active = isTabActive(item);
          return (
            <Link
              key={item.to}
              to={item.to}
              className={`tools-nav-tab ${active ? "active" : ""}`}
            >
              <Icon size={16} />
              <span>{item.label}</span>
            </Link>
          );
        })}
      </nav>
    </div>
  );
};

export default ToolsHeader;
